// Shared, experience-scoped state for the "next video" prompt.
//
// The inline NextVideoBlock lives inside the active shop-window, so switching
// tabs unmounts + remounts it (each tab is a distinct keyed FadeTransition).
// Component-local `dismissed` state would therefore reset on every tab switch —
// silently un-cancelling the auto-advance after the viewer pressed Cancel.
//
// Keep the dismissed flag here instead: a module singleton survives the remount
// and resets only on a real experience swap. This matches the chain store /
// ChainSession, which are already singletons for the one active experience.
let _id: unknown = null;
let _dismissed = false;

const chainPrompt = {
  // Scope the flag to the current experience; a real swap clears it so the
  // freshly-chained experience gets its own prompt + countdown.
  syncExperience(id: unknown) {
    if (id !== _id) {
      _id = id;
      _dismissed = false;
    }
  },

  // Record that the viewer dismissed the prompt for `id` (Cancel, or the
  // auto-advance firing). Guarded by id so a stale call can't dismiss the wrong
  // experience.
  dismiss(id: unknown) {
    if (id != null && id === _id) {
      _dismissed = true;
    }
  },

  isDismissed(id: unknown): boolean {
    return _id != null && id === _id && _dismissed;
  },
};

export default chainPrompt;
